import React from 'react'

import PropTypes from 'prop-types'

import JoditEditor from 'jodit-react'

/**
 * @param {{
 *    onChange?: any
 *    value?: string
 * }} props
 * @returns {React.Component}
 */
const ZariWysiwyg = ({ value, onChange }) => {
  return (
    <JoditEditor
      value={value}
      onChange={newContent => {}}
      onBlur={onChange}
      config={{
        buttons: ['bold', 'strikethrough', 'underline', 'italic', 'fontsize'],
        buttonsMD: ['bold', 'strikethrough', 'underline', 'italic', 'fontsize'],
        buttonsXS: ['bold', 'strikethrough', 'underline', 'italic', 'fontsize']
      }}
    />
  )
}

ZariWysiwyg.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any
}

export default ZariWysiwyg
